<script setup lang="ts">
import { useOnTimezoneChange } from '@entities/viewer'

import { useTeamsApi } from '../api/teams/list.hook'
import TableTeams from './teams/TableTeams.vue'
import ModalCreateTeam from './teams/modals/ModalCreateTeam.vue'
import ModalDeleteTeam from './teams/modals/ModalDeleteTeam.vue'

defineOptions({
  name: 'TeamsListPage',
})

onMounted(() => {
  void useTeamsApi()
})

// Timestamps arrive pre-shifted into the admin's view timezone, so a timezone change needs a
// refetch rather than a client-side re-format.
useOnTimezoneChange(() => {
  void useTeamsApi()
})
</script>

<template>
  <TableTeams />
  <ModalCreateTeam />
  <ModalDeleteTeam />
</template>
